<template>
  <!-- v-show mantiene el elemento en el DOM y la clase controla la transición/visibilidad -->
  <div class="cart-overlay" :class="{ 'is-open': isOpen }" v-show="isOpen" @click.self="toggleCart">
    <aside class="cart-drawer">
      <div class="cart-header">
        <h3>Tu Carrito</h3>
        <button class="close-btn" @click="toggleCart">✕</button>
      </div>

      <div class="cart-body">
        <p v-if="items.length === 0" class="empty-msg">Tu carrito está vacío</p>
        
        <div v-else class="cart-item" v-for="item in items" :key="item.id">
          <div class="item-details">
            <h4>{{ item.name }}</h4>
            <p>${{ item.price }} c/u</p>
          </div>
          <div class="item-controls">
            <button @click="updateQuantity(item.id, -1)">-</button>
            <span>{{ item.quantity }}</span>
            <button @click="updateQuantity(item.id, 1)">+</button>
            <button class="delete-btn" @click="removeItem(item.id)">🗑️</button>
          </div>
        </div>
      </div>

      <div class="cart-footer" v-if="items.length > 0">
        <div class="total-row">
          <span>Total:</span>
          <strong>${{ total.toFixed(2) }} MXN</strong>
        </div>
        <button class="btn-whatsapp" @click="sendToWhatsApp">
          Completar pedido por WhatsApp 📱
        </button>
      </div>
    </aside>
  </div>
</template>

<script setup>
import { useCart } from '@/components/composables/cartStore';

const { items, isOpen, total, removeItem, updateQuantity, toggleCart } = useCart();

const sendToWhatsApp = () => {
  
  const phone = "5212283616313"; // Pon tu número aquí
  let message = "¡Hola! Quisiera realizar el siguiente pedido:\n\n";

  items.value.forEach(item => {
    message += `▪️ *${item.quantity}x* ${item.name} - $${(item.price * item.quantity).toFixed(2)}\n`;
  });

  message += `\n*Total a pagar: $${total.value.toFixed(2)} MXN*\n\n¿Me podrías indicar los datos para realizar el pago?`;

  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
};
</script>

<style scoped>
.cart-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 9999;
}

/* CuandoisOpen cambia a true, se activa esta clase */
.cart-overlay.is-open {
  opacity: 1;
  pointer-events: auto;
}

.cart-drawer {
  width: 100%;
  max-width: 400px;
  height: 100%;
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.cart-overlay.is-open .cart-drawer {
  transform: translateX(0);
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.cart-body {
  flex: 1;
  overflow-y: auto;
  padding: 15px 0;
}

.cart-footer {
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.btn-whatsapp {
  width: 100%;
  background-color: #25d366;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
}
</style>